import axiosClient from "./axiosClient";

const serviceUrl = "";

const accountService = {
  getAccounts: async (page = 1, size = 20) => {
    const url = `/core-manager/account/list-account`;

    const params = { page: page, size: size };
    const response = await axiosClient.get(url, { params: params });

    return response.data;
  },
  getAccount: async (id) => {
    const url = serviceUrl + `/accounts/${id}`;
    const response = await axiosClient.get(url);
    return response;
  },
  getAccountByUsername: async (username) => {
    const url = serviceUrl + `/accounts/search/findByUsername`;
    const params = { username: username };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  getRoleApi: async (id) => {
    const url = serviceUrl + `/authorization/roleApis`;
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
};

export default accountService;
